import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="variant-selector"
export default class extends Controller {
  static targets = ["optionInput", "skuInput", "priceDisplay", "selectedLabel"]
  static values = { variants: Array }

  connect() {
    // Pre-select from URL params
    const urlParams = new URLSearchParams(window.location.search)
    const skuParam = urlParams.get("sku_id")

    if (skuParam && this.variantsValue.length > 0) {
      const matched = this.variantsValue.find(v => String(v.id) === String(skuParam))
      if (matched && matched.options) {
        matched.options.forEach((optValue, idx) => {
          const groupInputs = this.optionInputTargets.filter(inp => inp.name === `option_${idx}`)
          groupInputs.forEach(inp => {
            inp.checked = (inp.value === optValue)
          })
        })
      }
    }

    this._updateVariant()
  }

  select() {
    this._updateVariant()
  }

  _updateVariant() {
    if (this.variantsValue.length === 0) return

    const selectedOptions = this._getSelectedOptions()
    const matched = this._findMatchingVariant(selectedOptions)

    if (matched) {
      // Update hidden sku_id input
      if (this.hasSkuInputTarget) {
        this.skuInputTarget.value = matched.id
      }

      // Update price display
      if (this.hasPriceDisplayTarget) {
        this.priceDisplayTarget.innerText = matched.price_money
      }

      // Update URL
      try {
        const url = new URL(window.location.href)
        url.searchParams.set("sku_id", matched.id)
        window.history.replaceState({}, "", url.toString())
      } catch (e) { /* ignore */ }

      // Update selected labels
      if (this.hasSelectedLabelTarget) {
        this.selectedLabelTargets.forEach((label, idx) => {
          label.innerText = selectedOptions[idx] || ""
        })
      }

      // Dispatch event for other controllers (e.g. cart controller)
      this.dispatch("changed", { detail: { variant: matched } })
    }
  }

  _getSelectedOptions() {
    const options = []
    const groupNames = [...new Set(this.optionInputTargets.map(inp => inp.name))]

    groupNames.forEach(name => {
      const checked = this.optionInputTargets.find(inp => inp.name === name && inp.checked)
      if (checked) options.push(checked.value)
    })

    return options
  }

  _findMatchingVariant(selectedOptions) {
    return this.variantsValue.find(variant => {
      if (!variant.options) return false
      for (let i = 0; i < selectedOptions.length; i++) {
        if (String(variant.options[i] || "").trim() !== String(selectedOptions[i] || "").trim()) {
          return false
        }
      }
      return true
    })
  }
}
